import { shallowEqual, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { SelectionInfo } from 'dragonmouse-shared/devigner';
import { selectFrame } from 'redux/db/reducers';
import { setInspectorRightPanelWidth } from 'redux/mode/actions';
import { RootReducer } from 'redux/reducers';
import ResizablePanel from '../ResizablePanel';
import * as Base from '../styles';
import * as S from './styles';
import FrameInfo from './FrameInfo';
import ElementInfo from './ElementInfo';

interface InspectorRightPanelProps {
	frameId: string;
	selectionInfo: SelectionInfo | null;
	overlay?: boolean;
	visible?: boolean;
	onMouseEnter?: () => void;
	onMouseLeave?: () => void;
}

const InspectorRightPanel = ({
	frameId,
	selectionInfo,
	overlay,
	visible = true,
	onMouseEnter,
	onMouseLeave,
}: InspectorRightPanelProps) => {
	const dispatch = useDispatch();

	const { frame, selectedDomElements, inspectorRightPanelWidth } = useSelector((r: RootReducer) => {
		return {
			frame: selectFrame(r.db, frameId),
			selectedDomElements: r.mode.selectedDomElements,
			inspectorRightPanelWidth: r.mode.inspectorRightPanelWidth,
		};
	}, shallowEqual);

	if (!frame) return null;

	const isElementSelected = selectedDomElements.length > 0 && !!selectionInfo;

	return (
		<S.PanelWrapper
			$overlay={overlay}
			$visible={visible}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			data-panel
		>
			<ResizablePanel
				resizeOnSide="left"
				size={inspectorRightPanelWidth}
				onResize={(w) => dispatch(setInspectorRightPanelWidth(w))}
			>
				<Base.Base>
					<Base.Divider />
					{isElementSelected && frame.siteId ? (
						<ElementInfo frame={frame} selectionInfo={selectionInfo} />
					) : (
						<FrameInfo frame={frame} />
					)}
				</Base.Base>
			</ResizablePanel>
		</S.PanelWrapper>
	);
};

export default InspectorRightPanel;
